<template>
  <div class="view">
    <div class="book">
      <nav class="nav" style="position: absolute; align-self: start">
        <img class="nav__logo" src="../assets/fast.jpg" alt="Fast logo">
        <router-link to="/" class="menu__item">
          <img class="menu__icon" src="../assets/chevron-left-solid.svg" alt="Cofnij">
          <span class="menu__text">COFNIJ</span>
        </router-link>
      </nav>
      <flipbook class="flipbook" style="position: relative;" v-slot="flipbook" :pages="pages">
        <div style="position: absolute; display: flex; justify-content: space-between; align-items: center; width: 100%; height: 100%; pointer-events: none; padding: 0 20px; box-sizing: border-box;">
          <a @click="flipbook.flipLeft">
            <img style="width: 50px" src="../assets/chevron-left-solid.svg" alt="Poprzednia">
          </a>
          <a @click="flipbook.flipRight">
            <img style="width: 50px" src="../assets/chevron-right-solid.svg" alt="Następna">
          </a>
        </div>
      </flipbook>
    </div>
  </div>
</template>

<script>
  import Flipbook from 'flipbook-vue'
  export default {
    name: "Book",
    components: {
      Flipbook
    },
    data() {
      return {
        slug: null,
        book: {},
        pages: []
      }
    },
    methods: {
      getManifest() {
        if(this.slug){
          this.axios.get('/books/manifest.json')
            .then(response => {
              const manifest = response.data;
              if(manifest.books && manifest.books[this.slug]){
                this.book = Object.assign({}, manifest.books[this.slug]);
                this.$nextTick(() => {
                  this.generatePages();
                });
              }
            })
            .catch(error => {
              console.log(error);
            })
        }
      },
      generatePages() {
        let pages = [];
        let digits = this.book.pages.count.toString().length;
        for(let i = 1; i <= this.book.pages.count; i++){
          let number = i;
          if(this.book.append_zero){
            for(let j = 0; j < (digits - i.toString().length); j++){
              number = '0' + number;
            }
          }
          pages.push('/books/' + this.slug + '/' + this.book.pages.prefix + number + this.book.pages.suffix + this.book.pages.extension);
        }
        this.pages = [null].concat(pages);
      }
    },
    mounted() {
      this.slug = this.$route.params.slug;
      this.getManifest();
    }
  }
</script>

<style lang="scss">
  .flipbook {
    width: 100%;
    height: 80vh;
    margin: 60px auto 0;
    .bounding-box {
      box-shadow: 0 0 20px rgba(0, 0, 0, .6);
    }
  }

  .book {
    overflow: hidden;
    width: 100%;
    height: 100vh;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
  }

  .menu {
    &__text {
      padding-bottom: 3px;
    }

    &__icon {
      height: 30px;
      margin-right: 10px;
    }

    &__item {
      margin-left: 10px;
      display: flex;
      align-items: center;
      padding: 10px;
      text-decoration: none;
      color: #333333;
      font-weight: bold;
      font-size: 24px;
    }
  }

  @media (min-width: 640px) {
    .flipbook {
      margin: 0 auto;
    }
  }
</style>
